import type { SessionArea } from '#imports';
// Session-timeout state machine. Domain state only: timers and route->regime wiring live in
// plugins/search-timeout.client.ts; the modal's visibility is view state, local to the dialog.
type OfferExpirationPhase = 'idle' | 'warning' | 'expired';

interface OfferExpirationStore {
  phase: OfferExpirationPhase;
  regime?: SessionArea;
  guaranteedMinutes: number;
}

export const useOfferExpirationStore = defineStore('search-timeout', {
  state: (): OfferExpirationStore => ({
    phase: 'idle',
    regime: undefined,
    guaranteedMinutes: 0,
  }),
  getters: {
    open: (state) => state.phase === 'warning' || state.phase === 'expired',
  },
  actions: {
    activate(regime: SessionArea, guaranteedMinutes: number) {
      this.regime = regime;
      this.guaranteedMinutes = guaranteedMinutes;
      this.phase = 'idle';
    },
    markWarning() {
      this.phase = 'warning';
    },
    markExpired() {
      this.phase = 'expired';
    },
    dismiss() {
      this.phase = 'idle';
    },
  },
});
